import type {Industry, Job, Technology} from '~/types/cms'
import type {Populated} from '~/types/populated'
import {extractDocs} from '~/utils/transform-payload'

export interface NavData {
  industries: Populated<Industry>[]
  technologies: Populated<Technology>[]
  jobs: Populated<Job>[]
}

const NAV_DATA_KEY = 'nav-data'

export function useNavData() {
  const state = useState<NavData>(
    NAV_DATA_KEY,
    () =>
      ({
        industries: [],
        technologies: [],
        jobs: [],
      }) as NavData
  )

  const sdk = usePayloadSdk()

  async function fetchNavData(): Promise<NavData> {
    const [industriesRes, technologiesRes, jobsRes] = await Promise.all([
      sdk.find({
        collection: 'industries',
        limit: 1000,
        where: {_status: {equals: 'published'}},
      }),
      sdk.find({
        collection: 'technologies',
        limit: 100,
        where: {_status: {equals: 'published'}},
      }),
      sdk.find({
        collection: 'jobs',
        depth: 1,
        limit: 1000,
        where: {_status: {equals: 'published'}},
      }),
    ])

    const data: NavData = {
      industries: extractDocs(industriesRes),
      technologies: extractDocs(technologiesRes).filter(tech => !!tech.description),
      jobs: extractDocs(jobsRes),
    }

    state.value = data
    return data
  }

  return {fetchNavData, nav: state}
}
